export default __webpack_public_path__ + "static/media/ShenideSho.e00a564f.svg";